import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ConfigContextProvider } from "./hooks";

const container: any = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ConfigContextProvider windowConfig={(window as any).config}>
      <App />
    </ConfigContextProvider>
  </React.StrictMode>
);
